import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class SettingsIndexRoute extends Route {
	@service('navigation') declare navigationService: Service.Navigation;
	@service('current-user') declare currentUserService: Service.CurrentUser;

	override beforeModel() {
		const redirectPath = this.currentUserService.isAdmin
			? 'settings.users'
			: 'settings.notifications';
		this.navigationService.transitionToRoute(redirectPath);
	}
}
